import React, { useEffect } from "react";
import { useGlobalContext } from "../Context/GlobalContext";
import { useLocation } from "react-router-dom";

const ReportsNavbar = () => {
  const location = useLocation();
  const payload = location.state;

  const { setActiveReportPage, activeReportPage } = useGlobalContext();

  const handleBtnClick = (page) => {
    setActiveReportPage(page);
  };

  useEffect(() => {
    if (payload?.activeReportPage) {
      setActiveReportPage(payload.activeReportPage);
    }
  }, [payload, setActiveReportPage]);

  const pages = [
    "DRM`s Diary New",
    "7A Loading",
    "Punctuality",
    "Operating Indices",
    "Asset Failure",
    "Other Reports",
    "Milestones",
    "CHC Report",
    "Message Monitor",
  ];

  return (
    <div className="ms-2 me-2">
      <div className="reports-navbar ">
        <div className="reports-navbar-inner">
          <div className="reports-title">
            <span className="reports-title-line"></span>
            <span>Reports</span>
          </div>

          <div className="reports-buttons">
            {pages.map((pageName, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleBtnClick(pageName)}
                className={`report-nav-btn ${
                  activeReportPage === pageName ? "report-nav-active" : ""
                }`}
              >
                <span className="report-nav-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="report-nav-text">{pageName}</span>

                <span className="report-nav-arrow">›</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsNavbar;
